<template>
  <v-container>
    <v-row>
      <v-col cols="12" sm="2">
        <div class="d-flex align-center" style="height: 100%">
          <v-tooltip bottom v-if="$checkPermission('print_enrolled_students')">
            <template v-slot:activator="{ on }">
              <v-btn
                  v-on="on"
                  small
                  dark
                  color="primary"
                  height="44"
                  depressed
                  @click="printPage()"
              >
                <v-icon>mdi-cloud-print-outline</v-icon>
              </v-btn>
            </template>
            <span>Ispis</span>
          </v-tooltip>
          <v-tooltip
              v-if="$checkPermission('department invalidate order numbers')"
              bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                  v-on="on"
                  small
                  dark
                  color="primary"
                  height="44"
                  class="ml-2"
                  depressed
                  @click="invalidateOrderNumbers()"
              >
                <v-icon>mdi-restore</v-icon>
              </v-btn>
            </template>
            <span>Sortiraj učenike abecedno i zaključaj odjel</span>
          </v-tooltip>
        </div>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="12" sm="10">
        <v-row>
          <v-spacer></v-spacer>
          <v-col
              cols="12"
              sm="4"
              lg="4"
          >
            <department-students-get-enrollments-dialog
                v-if="!isEnrollmentsLocked && ['11','1'].includes(schoolClass)"
                :loaded-students="loadedStudents"
                :enrolled-students="items"
                @load-students="loadStudentsUpisi"
                @save-students="transferStudentsUpisi"
            ></department-students-get-enrollments-dialog>
            <v-btn
                v-if="!isEnrollmentsLocked && !['11','1'].includes(schoolClass) && $checkPermission('transfer_students_from_last_year_button')"
                class="text-none"
                depressed
                height="44"
                color="secondary"
                block
                @click="openTransferDialog()"
            >
              <v-icon class="mr-2">mdi-transfer</v-icon>
              Prebačaj iz prethodne
            </v-btn>
          </v-col>

          <v-col
              cols="12"
              sm="6"
              lg="4"
              v-if="
              $checkPermission('department lock enrollments') &&
                items.length > 0
            "
          >
            <v-btn
                v-if="!isEnrollmentsLocked"
                class="text-none"
                depressed
                height="44"
                color="error"
                block
                @click="openDialog(1)"
            >
              <v-icon class="mr-2">mdi-lock</v-icon>
              Zaključaj učenike
            </v-btn>
            <v-btn
                v-else
                class="text-none"
                depressed
                height="44"
                color="error"
                block
                @click="openDialog(0)"
            >
              <v-icon class="mr-2">mdi-lock</v-icon>
              Otključaj učenike
            </v-btn>
          </v-col>

          <v-col
              v-if="$checkPermission('department_enrollment create')"
              cols="12"
              sm="6"
              lg="4"
          >
            <v-btn
                color="primary"
                height="44"
                dark
                block
                depressed
                class="text-none"
                v-if="!isEnrollmentsLocked"
                @click="showAddForm()"
            >
              <v-icon left size="20">mdi-pencil</v-icon>
              Uredi
            </v-btn>
            <v-tooltip bottom v-else>
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on">
                  <v-btn
                      color="primary"
                      height="44"
                      block
                      depressed
                      disabled
                      class="text-none"
                  >
                    <v-icon left size="20">mdi-pencil</v-icon>
                    Uredi
                  </v-btn>
                </div>
              </template>
              <span>Nije moguće jer su učenici zaključani</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-data-table
            :headers="headers"
            :items="items"
            :loading="loading"
            :options.sync="options"
            :server-items-length="serverItemsLength"
            :sort-by.sync="sortBy"
            :items-per-page="50"
            :sort-desc.sync="sortDesc"
            hide-default-footer
            @click:row="openStudentDetails"
            style="cursor: pointer"
            class="elevation-1"
            loading-text="Traženje..."
            :footer-props="{ itemsPerPageText: 'Redaka po stranici:' }"
        >
          <template v-slot:no-data>
            <span> Za tražene pojmove nema rezultata pretrage. </span>
          </template>

          <template v-slot:item.action="{item}">
                <div class="d-flex align-center" style="height: 100%">
                  <v-tooltip
                      v-if="$checkPermission('student record delete')"
                      small
                      bottom
                    >
                    <template v-slot:activator="{ on }">
                      <v-btn
                          v-on="on"
                          x-small
                          dark
                          color="red"
                          height="44"
                          depressed
                          class="mx-2"
                          @click.stop="openDeleteStudentConfirm(item)"
                      >
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </template>
                    <span>Ukloni iz odjela</span>
                  </v-tooltip>

                  <v-tooltip
                      v-if="$checkPermission('student record delete')"
                      small
                      bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                          v-on="on"
                          x-small
                          dark
                          color="blue"
                          height="44"
                          depressed
                          @click.stop="openTransferStudentConfirm(item)"
                      >
                        <v-icon>mdi-swap-horizontal</v-icon>
                      </v-btn>
                    </template>
                    <span>Prebačaj</span>
                  </v-tooltip>
                </div>
          </template>

          <template v-slot:[`footer.page-text`]="items">
            Prikazano {{ items.pageStart }} do {{ items.pageStop }} od ukupno
            {{ items.itemsLength }} rezultata
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <v-dialog v-model="dialog" width="500" @click:outside="dialog = false">
      <v-card>
        <v-card-title primary-title> Jeste li sigurni?</v-card-title>

        <v-card-text style="padding-top: 20px">
          {{ dialogText }} <br/>
          <div v-if="lockEnrollments">
            <span class="font-weight-bold">Upozorenje:</span>
            Kada zaključate odjeljenje više nećete moći dodavati učenike.
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              @click="dialog = false"
              class="text-none"
              depressed
              large
              outlined
          >Odustani
          </v-btn
          >
          <v-btn
              color="error"
              class="text-none"
              @click="lockDepartment"
              depressed
              large
          >{{ dialogBtn }}
          </v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <confirm-dialog
        v-model="deleteStudentDialog"
        confirm-text="Obriši"
        @confirm="deleteStudentRecord"
        @cancel="closeDeleteStudentDialog"
    >
      Jeste li sigurni da želite obrisati učenika? <br/>
      <div v-if="lockEnrollments">
        <span class="font-weight-bold">Upozorenje:</span>
        Ovo briše sve podatke vezano za ovog učenika.
      </div>
    </confirm-dialog>

    <v-dialog v-model="transferDialog" width="500" @click:outside="dialog = false">
      <v-card>
        <v-card-title primary-title> Jeste li sigurni?</v-card-title>

        <v-card-text style="padding-top: 20px">
          Prebačaj učenika u višu godinu<br/><br/>
          <div v-if="lockEnrollments">
            <span class="font-weight-bold">Upozorenje:</span>
            Kada zaključate odjeljenje više nećete moći prebacivati učenike.
          </div>

          <div>
            <v-autocomplete
                outlined
                dense
                placeholder="Odaberite školsku godinu"
                :items="schoolYears"
                item-text="title"
                item-value="id"
                @change="loadDepartments()"
                v-model="selectedSchoolYear"
            >
            </v-autocomplete>

          </div>
          <div>
            <v-autocomplete
                outlined
                dense
                placeholder="Odaberite odjeljenje"
                :items="departments"
                item-text="label"
                item-value="id"
                @change="loadStudents()"
                v-model="selectedDepartment"
            >
            </v-autocomplete>

          </div>

          <div>
            <v-form>
              <v-row v-for="(item, index) in loadedStudents" :key="index">
                <v-col cols="4">
                  <v-subheader class="justify-end">Učenik/ca:</v-subheader>
                </v-col>
                <v-col v-if="item.id" cols="6">
                  <v-autocomplete
                      :items="loadedStudents"
                      item-value="id"
                      item-text="full_name"
                      v-model="item.id"
                      height="44"
                      @input="addUserField"
                      dense
                      hide-details
                      outlined
                      single-line
                      hide-no-data
                      disabled
                  >
                    <template slot="item" slot-scope="{item}">
                      {{ item.full_name }} - {{ item.aai_email ? item.aai_email : '' }}
                    </template>
                    <template slot="selection" slot-scope="{item}">
                      {{ item.full_name }} - {{ item.aai_email ? item.aai_email : '' }}
                    </template>
                  </v-autocomplete>
                </v-col>

                <v-col v-else cols="6">
                  <v-autocomplete
                      :items="loadedStudents"
                      placeholder="Odaberite učenika"
                      item-value="id"
                      item-text="full_name"
                      v-model="item.id"
                      height="44"
                      @input="addUserField"
                      dense
                      hide-details
                      outlined
                      single-line
                      hide-no-data
                  >
                    <template slot="item" slot-scope="{item}">
                      {{ item.full_name }} - {{ item.aai_email }}
                    </template>
                    <template slot="selection" slot-scope="{item}">
                      {{ item.full_name }} - {{ item.aai_email }}
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col class="d-flex justify-end">
                  <v-btn
                      height="44"
                      style="min-width: 44px; width: 44px"
                      class="red darken-2 elevation-0"
                      @click="deleteUserField(index)"
                  >
                    <v-icon size="20" color="white">mdi-close</v-icon>
                  </v-btn>
                </v-col>
              </v-row>

              <!--              <v-row>-->
              <!--                <v-spacer></v-spacer>-->
              <!--                <v-col cols="8">-->
              <!--                  <v-btn-->
              <!--                      height="44"-->
              <!--                      text-->
              <!--                      class="text-none secondary&#45;&#45;text"-->
              <!--                      @click="addUserField"-->
              <!--                  >-->
              <!--                    + Dodaj polje-->
              <!--                  </v-btn>-->
              <!--                </v-col>-->
              <!--              </v-row>-->
            </v-form>

          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              @click="transferDialog = false"
              class="text-none"
              depressed
              large
              outlined
          >Odustani
          </v-btn
          >
          <v-btn
              color="error"
              class="text-none"
              @click="transferStudents()"
              depressed
              large
          >Prebaci učenike
          </v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <confirm-dialog
        v-model="transferStudentDialog"
        confirm-text="Prebaci"
        @confirm="transferStudentRecord"
        @cancel="closeTransferStudentDialog"
    >
      Jeste li sigurni da želite prebaciti učenika?
    </confirm-dialog>

  </v-container>
</template>

<script>
import {serverBus} from "@/main";
import ApiV2 from "@/services/ApiV2";
import DepartmentStudentsGetEnrollmentsDialog from "../../../dialogs/DepartmentStudentsGetEnrollmentsDialog";
import ConfirmDialog from "../../../dialogs/ConfirmDialog";

export default {
  components: {ConfirmDialog, DepartmentStudentsGetEnrollmentsDialog},
  created() {
    if (localStorage.getItem("department-students")) {
      this.options = JSON.parse(localStorage.getItem("department-students"));
    }
    serverBus.$on("perform-search", (search_value) => {
      this.search = search_value;
    });

    serverBus.$on("filters-changed", (filters) => {
      this.options.filters = filters;
    });

    serverBus.$on("delete-item", (item) => {
      this.deleteItem(item);
    });

    serverBus.$on(["reload-all-data", "reload-table-data"], () => {
      this.getDataFromApi();
    });
  },

  methods: {
    openTransferStudentConfirm(item){
      this.studentForTransfer = item
      this.transferStudentDialog = true;
    },
    closeTransferStudentDialog(){
      this.studentForTransfer = null
      this.transferStudentDialog = false;
      this.getDataFromApi()
    },
    async transferStudentRecord(){
      await ApiV2.post(`department_enrollment/${this.studentForTransfer?.pivot?.id}/transfer`)
      this.closeTransferStudentDialog()
    },
    openDeleteStudentConfirm(item){
      this.studentForDelete = item
      this.deleteStudentDialog = true;
    },
    closeDeleteStudentDialog(){
      this.studentForDelete = null
      this.deleteStudentDialog = false;
      this.getDataFromApi()
    },
    deleteStudentRecord(){
      ApiV2.post(`department_enrollment/${this.studentForDelete?.pivot?.id}/hard_delete_record`)
      this.closeDeleteStudentDialog()
    },
    openDialog(lock) {
      this.dialog = true;
      this.lockEnrollments = lock;
      if (lock === 1) {
        this.dialogText = "Jeste li sigurni da želite zaključati odjeljenje?";
        this.dialogBtn = "Zaključaj";
      } else {
        this.dialogText = "Jeste li sigurni da želite otključati odjeljenje?";
        this.dialogBtn = "Otključaj";
      }
    },

    async invalidateOrderNumbers() {
      await ApiV2.post('departments/' + this.$route.params.odjeljenje_id + '/invalidate_order_numbers');
      this.loadedStudents = [];
      this.getDataFromApi();
    },

    async openTransferDialog() {
      let {data} = await ApiV2.get('school_years', {
        params: {
          perPage: -1,
        }
      });
      this.schoolYears = data.data;
      this.transferDialog = true;
    },

    async loadDepartments() {
      let {data} = await ApiV2.get('departments', {
        params: {
          perPage: -1,
          transferStudents: 1,
          filter: {
            school_year_id: this.selectedSchoolYear
          }
        }
      });
      this.departments = data.data;
    },

    async loadStudents() {
      let {data} = await ApiV2.get('departments/' + this.selectedDepartment + '/users', {
        params: {
          perPage: -1,
        }
      });
      this.loadedStudents = data.data;
    },

    async loadStudentsUpisi() {
      // ruta za dohvat ucenika iz smjera
      let {data} = await ApiV2.get('user_enrollment_history/school_educational_field/' + this.schoolEducationalFieldId);
      this.loadedStudents = data;
    },

    async transferStudents() {
      let formData = {"data": this.loadedStudents.map(s => s.id), "method": "sync"}
      let {data} = await ApiV2.post('departments/' + this.$route.params.odjeljenje_id + '/users', formData);
      console.log(data);
      this.loadedStudents = [];
      this.getDataFromApi();
      this.transferDialog = false;
    },

    async transferStudentsUpisi(studentIds = []) {
      let formData = {"data": studentIds, "method": "sync"}
      await ApiV2.post('departments/' + this.$route.params.odjeljenje_id + '/users', formData);
      this.loadedStudents = [];
      this.getDataFromApi();
    },

    // addUserField(){
    //   this.loadedStudents.push({
    //     id: null,
    //     users: (this.users.length > 0 || this.selectedYears.length > 0) ? this.filterUsers(this.users) : this.filterUsers(this.allUsers),
    //     allUsers: this.allUsers
    //   });
    // },
    deleteUserField(index) {
      this.loadedStudents.splice(index, 1);

      // ako je korisnik obrisan pa ga nema u novom fieldu
      this.loadedStudents.forEach((user, i) => {
        if (user.id === null) {
          this.loadedStudents.splice(i, 1);
          // this.addUserField();
        }
      })
    },

    showAddForm() {
      this.$navigate(
          `/admin/odjeljenje/pregled/${this.$route.params.odjeljenje_id}/ucenik/dodaj`
      );
    },

    openStudentDetails(student) {
      this.$navigate(
          `/admin/odjeljenje/pregled/${this.$route.params.odjeljenje_id}/ucenik/${student.id}`
      );
    },

    getDataFromApi() {
      this.loading = true;
      this.items = [];

      ApiV2.get(`departments/${this.$route.params.odjeljenje_id}`, {
        params: {
          perPage: -1,
          with: "users",
        },
      })
          .then((response) => {
            this.items = response.data.users;

            this.isEnrollmentsLocked = response.data.lock_enrollments;
            this.serverItemsLength = response.data.total;
            this.schoolClass = response.data.school_class
            this.schoolEducationalFieldId = response.data.school_educational_field_id

            this.$store.commit("setData", this.items);
          })
          .catch(() => {
            this.items = [];
          })
          .finally(() => {
            this.loading = false;
          });
    },

    lockDepartment() {
      ApiV2.post(
          `departments/${this.$route.params.odjeljenje_id}/lock_enrollments`,
          {
            lock_enrollments: this.lockEnrollments,
          }
      )
          .then(() => {
            this.getDataFromApi();
            this.dialog = false;
            serverBus.$emit("show-snackbar", true);
          })
          .catch(() => {
            serverBus.$emit("show-snackbar", false);
          });
    },

    printPage() {
      this.getCurrentTime();
      setTimeout(function () {
        window.print();
      }, 200);
    },

    getCurrentTime() {
      let today = new Date();
      this.currentTime = today.toLocaleString();
    },
  },

  computed: {
    headers() {
      return [
        {text: "Broj", value: "pivot.enrollment_number"},
        {text: "Ime", value: "first_name"},
        {text: "Prezime", value: "last_name"},
        {text: "JMBG", value: "jmbg"},
        {text: "eduID", value: "aai_email"},
        {text: "Email(osobni)", value: "email_private"},
        {text: "Akcija", value: "action"},
      ];
    },
  },

  watch: {
    options: {
      handler() {
        /*
                    if (this.options.itemsPerPage === -1) {
                        serverBus.$emit('show-all-rows-warning');
                        return;
                    }
                     */
        localStorage.setItem(
            "department-students",
            JSON.stringify(this.options)
        );

        this.getDataFromApi();
      },
      deep: true,
    },

    search: {
      handler() {
        if (this.search.field !== null && this.search.phrase !== null) {
          let self = this;

          self.loading = true;

          clearTimeout(self.request);

          self.request = null;
          self.request = setTimeout(function () {
            self.options.search = self.search;
            self.getDataFromApi();
          }, 300);
        }
      },
      deep: true,
    },
  },

  beforeDestroy() {
    this.$destroyEvents();

    serverBus.$off("perform-search");
    serverBus.$off("filters-changed");
    serverBus.$off("delete-item");
    serverBus.$off("reload-all-data");
    serverBus.$off("reload-table-data");
  },

  data: function () {
    return {
      studentForTransfer: null,
      transferStudentDialog: false,
      studentForDelete: null,
      deleteStudentDialog: false,
      items: [],
      schoolEducationalFieldId: null,
      isEnrollmentsLocked: false,
      lockEnrollments: null,
      dialogText: "",
      dialogBtn: "",
      request: null,
      dialog: false,
      transferDialog: false,
      departments: [],
      schoolYears: [],
      loadedStudents: [],
      schoolClass: null,
      selectedSchoolYear: null,
      selectedDepartment: null,
      sortBy: "pivot.enrollment_number",
      sortDesc: false,
      search: {
        phrase: null,
        field: null,
      },
      options: {
        filters: {},
        itemsPerPage: 50
      },
      loading: true,
      serverItemsLength: 0,
    };
  },
};
</script>
